// extracted by mini-css-extract-plugin
export default {"dialog":"n6Ad636yoYj7vjJn","subHeader":"p8C9bL69DFsybAYu","delete":"iYBPdENPeWAHYsL8","loading":"wCq6TcTagnIL4d0K"};